import styled from "styled-components";
import { FormSection, FormRow, FormField, FormLabel, FormInput, FormSelect } from "@/screen/Identities/Styles/IdentityFormStyles";
export { FormSection, FormRow, FormField, FormLabel, FormInput, FormSelect };

/** Sub-campo condicional que cuelga de una pregunta (p. ej. la otra nacionalidad). */
export const SubQuestionIndent = styled.div`
    margin-top: 16px;

    label
    {
        display: block;
        margin-bottom: 10px;
    }

    input
    {
        width: 100%;
        box-sizing: border-box;
    }
`;

export const QuestionText = styled.p`
    font-size: 14px;
    color: #2a4143;
    margin-bottom: 12px;
    line-height: 1.5;
    cursor: default;
`;

export const RadioGroup = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    margin-bottom: 8px;
`;

export const RadioLabel = styled.label`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #2a4143;
    cursor: pointer;
`;

export const RadioInput = styled.input`
    cursor: pointer;
`;

export const DisclaimerBox = styled.div`
    background-color: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 8px;
    padding: 16px 20px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 12px;

    &::before
    {
        content: "⚠";
        font-size: 18px;
        line-height: 1;
        width: 20px;
        min-width: 20px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    p
    {
        font-size: 14px;
        color: #856404;
        line-height: 1.5;
        margin: 0;
    }
`;

export const SearchableSelectWrapper = styled.div<{$pendingHighlight?: boolean; $invalid?: boolean; $disabled?: boolean}>`
    .react-dropdown-select
    {
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        min-height: 40px;
        max-height: 40px;
        padding: 0 12px;
        border: 1px solid ${(props) => props.theme?.palette?.inputBorder ?? "#d1d9db"} !important;
        border-radius: 8px;
        outline: none;
        color: ${(props) => props.theme?.palette?.neutralPrimary ?? "#2a4143"};
        background-color: ${(props) => props.theme?.palette?.inputBackground ?? "#ffffff"} !important;
        box-shadow: none !important;
        transition: border-color 0.2s ease;
        align-items: center;
    }

    .react-dropdown-select:hover
    {
        border-color: ${(props) => props.theme?.palette?.inputBorder ?? "#d1d9db"} !important;
    }

    ${(props) => props.$pendingHighlight && `
        .react-dropdown-select
        {
            border-color: #d4a012 !important;
            background-color: #fffbf0 !important;
            box-shadow: 0 0 0 1px rgba(212, 160, 18, 0.35) !important;
        }
    `}

    ${(props) => props.$invalid && `
        .react-dropdown-select
        {
            border-color: #a4262c !important;
        }
    `}

    .react-dropdown-select:focus-within
    {
        border-color: ${(props) => props.theme?.palette?.themePrimary ?? "#CC214F"} !important;
    }

    .react-dropdown-select-content
    {
        display: flex;
        align-items: center;
        min-width: 0;
        flex-wrap: nowrap;
        gap: 0;
    }

    .react-dropdown-select-content > span
    {
        display: block;
        flex: 1 1 auto;
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${(props) => props.theme?.palette?.neutralPrimary ?? "#2a4143"};
        font-size: 14px;
    }

    .react-dropdown-select-input
    {
        min-width: 72px !important;
        width: auto;
        flex: 1 1 120px;
        color: ${(props) => props.theme?.palette?.neutralPrimary ?? "#2a4143"} !important;
        font-size: 14px;
    }

    .react-dropdown-select-dropdown-handle
    {
        color: ${(props) => props.theme?.palette?.neutralPrimary ?? "#2a4143"};
    }

    .react-dropdown-select-dropdown
    {
        border: 1px solid ${(props) => props.theme?.palette?.inputBorder ?? "#d1d9db"};
        border-radius: 8px;
        box-shadow: 0 8px 24px rgba(8, 84, 117, 0.12);
        overflow-x: hidden;
        overflow-y: auto;
        overscroll-behavior: contain;
        -webkit-overflow-scrolling: touch;
        z-index: 40;
    }

    .react-dropdown-select-item
    {
        padding: 10px 12px;
        white-space: normal;
        overflow: visible;
        text-overflow: initial;
        font-size: 14px;
        color: ${(props) => props.theme?.palette?.neutralPrimary ?? "#2a4143"};
    }

    .react-dropdown-select-item:hover
    {
        background-color: ${(props) => props.theme?.palette?.neutralLighter ?? "#f5f7f9"};
    }

    ${(props) => props.$disabled && `
        .react-dropdown-select
        {
            background-color: ${props.theme?.palette?.neutralLighter ?? "#f5f7f9"} !important;
            color: ${props.theme?.palette?.neutralTertiaryAlt ?? "#95a0a1"};
            cursor: not-allowed;
        }
    `}
`;